// @flow
import * as React from 'react';
import { FormGroup, Col, ControlLabel } from 'react-bootstrap';
import type { Props } from './Props';

const Search = ({ children, title, enable = true }: Props): React.Element<any> => {
  if (!enable) {
    return <span />;
  }

  return (
    <FormGroup controlId="formHorizontalEmail">
      <Col componentClass={ControlLabel} sm={2}>
        {title}
      </Col>
      <Col sm={10}>
        {children}
      </Col>
    </FormGroup>
  );
};

export default Search;



// WEBPACK FOOTER //
// ./src/scenes/Admins/components/AdminSettings/components/InputGroup/InputGroup.js